import React from 'react';
import {Image} from 'react-native';
import Div from 'lib/Div';
import P from 'lib/P';
import {
  flowStyles, OutlineButton, PrimaryButton, ResultGlow, ResultIcon, SignatureResultSurface
} from 'modals/withdraw-flow/WithdrawFlowPrimitives';
import {colors, layout} from 'modals/withdraw-flow/theme';
import evenplayLogo from 'assets/img/evenplay-logo-long.svg';

type Props = {
  resultErrorMessage: string, canTryAgain: boolean, onTryAgain: () => void, onBackToAccount: () => void
};

const DepositErrorStep = ({resultErrorMessage, canTryAgain, onTryAgain, onBackToAccount}: Props) => (
  <>
    <Div h={56} row alignItems="center" px={12} bg="#1b3131">
      <Div w={56}/>
      <Div flex={1} alignItems="center">
        <Image source={evenplayLogo as any} style={flowStyles.resultBrandLogo}/>
      </Div>
      <Div w={56}/>
    </Div>

    <SignatureResultSurface scroll>
      <Div flex={1}>
        <Div alignItems="center" mt={28} position="relative">
          <ResultGlow tone="error"/>

          <ResultIcon
            icon="error" color={colors.statusLost} bg="rgba(255, 107, 107, 0.14)"
            borderColor={colors.statusLostSoft} rounded={999}
          />
        </Div>

        <Div alignItems="center" mt={20}>
          <P fontFamily="DavisSans-Regular" fs={30} lh={36} ta="center" color={colors.textPrimary}>
            Submission Error
          </P>
          <P fontFamily="DavisSans-Regular" fs={14} lh={20.3} color={colors.textSecondary} ta="center" mt={10}
             maxW={320}>
            {resultErrorMessage || 'Your deposit could not be completed. Please check your information and re-enter to try again.'}
          </P>
        </Div>

        <Div flex={1} minH={16}/>

        <Div gap={layout.methodGap}>
          {canTryAgain && <PrimaryButton label="Try Again" onPress={onTryAgain}/>}
          <OutlineButton label="Back to My Account" onPress={onBackToAccount}/>
        </Div>
      </Div>
    </SignatureResultSurface>
  </>
);

export default DepositErrorStep;
